import { createContext, useContext } from "react";
import { hasAnyCustomerRole } from "./customerRoles";

export const CustomerRolesContext = createContext({
  roles: [],
  rolesReady: false,
  hasAnyRole: () => false,
});

export function useCustomerRoles() {
  return useContext(CustomerRolesContext);
}

export function customerRolesContextValue(roles, rolesReady) {
  const normalized = Array.isArray(roles) ? roles : [];
  return {
    roles: normalized,
    rolesReady: Boolean(rolesReady),
    hasAnyRole: (required) =>
      rolesReady ? hasAnyCustomerRole(normalized, required) : false,
  };
}
